import CompanyClientsUnassignedContent from "../../features/companyClients/widgets/CompanyClientsUnassignedContent";

function CompanyClientsUnassignedScreen() {
  return <CompanyClientsUnassignedContent />;
}

export default CompanyClientsUnassignedScreen;
